import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import {
    memberdelete,
    memberlist,
    groupmemberlist,
    groupdetail,
} from "../../../services/admin";
import Swal from "sweetalert2";
import exportUrl from "../../../exportUrl";
import moment from "moment";
import { isAdmin, ROLE_EMPLOYEE } from "../../../utils/roles";

export default function Allmembers() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [urllink, setUrllink] = useState("");
    const [gname, setGname] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);
    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 160,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            className="btn-sm btn-info me-2" title="Member Detail"
                            onClick={() => navigate(`/member/memberdetail/${params.value}`)}
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                        {isAdmin() &&
                            <a
                                className="btn-sm btn-danger me-2" title="Delete Member"
                                onClick={() => memdelete(params.value)}
                            >
                                <i className="fa fa-trash"></i>
                            </a>
                        }
                        <a
                            className="btn-sm btn-success me-2" title="Member Profile"
                            onClick={() => navigate(`/member/memberprofile/${params.value}`)}
                        >
                            <i className="fa fa-user"></i>
                        </a>
                        <a className="btn-sm btn-warning me-2" title="Loan List" onClick={() => navigate(`/member/memberloanlist/${params.value}`)}>
                            <i className="fa fa-list"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Phone",
            field: "phone_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Alternate",
            field: "alternate_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Native",
            field: "native_place",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Added On",
            field: "created_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    const columnMDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 150,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.data.loan_count != 0) {
                    return (
                        <div className="text-center">
                            <a
                                className="btn-sm btn-danger me-2" onClick={() => navigate(`/loan/addloan/${params.value}`)}
                            >
                                <i className="fa fa-user"></i> Addon Loan
                            </a>

                        </div>
                    );
                } else {
                    return (
                        <div className="text-center">
                            <a
                                className="btn-sm btn-warning me-2"
                                onClick={() => navigate(`/loan/addloan/${params.value}`)}
                            >
                                <i className="fa fa-plus"></i> New Loan
                            </a>
                        </div>
                    );
                }
            },
        },
        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Phone",
            field: "phone_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Native",
            field: "native_place",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
         {
            headerName: "Added On",
            field: "created_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);
        funlist(path);
    }, [location.pathname]);

    function funlist(fpath) {
        setFilterProduct([]);
        if (fpath === "allmembers") {
            const temp = new FormData();
            temp.append("branch", localStorage.getItem("branch"));
            // Only Employees (role 4) are scoped to the members allocated to
            // them — i.e. members of the groups this staff collects. Passing
            // user_id makes the backend filter by group.group_collection_staff
            // (same rule the mobile agent app uses).
            //
            // Managers (role 3) and Admins are NOT scoped: they see every member
            // under their branch, so user_id is deliberately not sent for them.
            if (String(localStorage.getItem("Role")) === ROLE_EMPLOYEE) {
                temp.append("user_id", localStorage.getItem("UID"));
            }
            memberlist(temp).then((res) => {
                if (res.status === true) {
                    // setFilterProduct(res.data);
                    const formattedData = res.data?.map((item) => ({
                        ...item,
                        created_at: moment(item.created_at).format("DD-MM-YYYY"),
                    }));
                    setFilterProduct(formattedData);
                }
            });
        } else if (fpath === "memberlist") {
            groupdetail(id).then((res) => {
                if (res.status === true) {
                    setGname(res.data.group_name);
                }
            });
            groupmemberlist(id).then((res) => {
                if (res.status === true) {
                    setFilterProduct(res.data);
                }
            });
        }
    }

    function memdelete(mid) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                memberdelete(mid).then((response) => {
                    if (response.status === true) {
                        funlist(urllink);
                    }else{
                        toast.error(response.message); 
                    }
                });
            }
        });
    }

    // function downloadcard(mid) {

    //     window.open(exportUrl + 'report/memcardcarddownload/' + mid + '/excel' , "_blank");
    // }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Members</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Members</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Members
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            {urllink === "allmembers" && (
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        {" "}
                                        All Members Detail{" "}
                                    </h2>
                                </div>
                            )}
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-10">
                                        <h2 className="text-success main-content-title tx-24 mg-b-5">
                                            {gname}
                                        </h2>
                                    </div>
                                    {urllink === "memberlist" &&
                                        <div className="col-md-2 text-right">
                                            <a className="btn btn-info me-2" onClick={() => navigate(`/loan/allloan`)}>Back</a>
                                        </div>
                                    }

                                </div>


                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={
                                            urllink === "memberlist" ? columnMDefs : columnDefs
                                        }
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
